var map = {
	"./comments.svg": "12be",
	"./gaps.svg": "160a",
	"./highest.svg": "cf2f",
	"./list.svg": "99ad",
	"./lowest.svg": "4cb2",
	"./main.svg": "7895",
	"./overview.svg": "8dfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";